module.exports = __webpack_public_path__ + "static/media/sl_risk_score_trend_up.07025aaa.svg";